export default [
  {
    id: 1,
    name: 'CTO'
  },
  {
    id: 2,
    name: 'CEO'
  },
  {
    id: 3,
    name: 'CIO'
  },
  {
    id: 4,
    name: '联合创始人'
  },
  {
    id: 5,
    name: '技术VP/副总裁'
  },
  {
    id: 6,
    name: '总经理'
  },
  {
    id: 7,
    name: '高级技术总监'
  },
  {
    id: 8,
    name: '技术总监'
  },
  {
    id: 9,
    name: '运维总监'
  },
  {
    id: 13,
    name: '研发总监'
  },
  {
    id: 10,
    name: '技术经理／主管'
  },
  {
    id: 11,
    name: '首席架构师'
  },
  {
    id: 12,
    name: '其他'
  }
]
